import listFunctions from "@/data/functions/mixins/listFunctions.js";
export default {
  mixins: [listFunctions],
  methods: {
    defineRelationship(tagr) {
      let obj = null;
      let list = this.infoRelationshipsList;
      let index = this.findTagRelationshipThenReturnIndex(tagr, list);
      if (obj !== undefined) {
        obj = this.infoRelationshipsList[index];
      }
      return obj;
    },
    defineDocumentFromTag(tag) {
      let obj = null;
      let list = this.infoRelationshipsList;
      let index = this.findTagThenReturnIndex(tag, list);
      if (obj !== undefined) {
        obj = this.infoRelationshipsList[index];
      }
      return obj;
    }
  },
  data() {
    return {
      // eslint-disable-next-line
      infoRelationshipsList: [
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "User",
          titles: "Users",
          tag: "U1",
          tagr: "",
          n: "nu1", // stats primary
          no: "nu1o", // stats secondary open / active
          page: "/userdash",
          // eslint-disable-next-line
          des: "User can view and change data depending on the Company or Facility authentication levels, which are authorised by the Approvers.",
          icon: "person",
          icons: "home",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "AO",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Undefined",
          titles: "Error",
          tag: "NA",
          tagr: "",
          n: "nc1", // stats primary
          no: "nc1o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Company is the foundation of business operation which manages company wide policies, procedures, budgets and strategic plans. The company is essential to create new facility and management facility register.",
          icon: "error_outline",
          icons: "home",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "AO"
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Company",
          titles: "Companies",
          tag: "C1",
          tagr: "",
          n: "nc1", // stats primary
          no: "nc1o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Company is the foundation of business operation which manages company wide policies, procedures, budgets and strategic plans. The company is essential to create new facility and management facility register.",
          icon: "account_balance",
          icons: "home",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "AO",
          // eslint-disable-next-line
          help1: "Company is foundational for all business operations and it defines basic operations, values and strategic direction.",
          // eslint-disable-next-line
          help2: "Developed business processes apply to companywide policies, procedures, budgets, plans and strategic decisions. The company is essential to create new facility and management of facility register.",
          // eslint-disable-next-line
          help3: "New company request requires System Admin approval which validates Australian Business Number and Australian Corporation number against the Company Director. Access to approved company can be promoted and revoked at the discretion  the Company Custodian, who is responsible for Data Privacy protection of the company users."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Attachment",
          titles: "Attachments",
          tag: "D4",
          tagr: "",
          n: "nd4", // stats primary
          no: "ngdo", // stats secondary open / active
          // eslint-disable-next-line
          des: "Attachment to documents.",
          icon: "attachment",
          icons: "home",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "AO",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Role",
          titles: "Roles",
          tag: "G4",
          tagr: "",
          n: "ng4", // stats primary
          no: "ng4o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Roles and resposibilities list.",
          icon: "manage_accounts",
          icons: "home",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "AO",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Facility",
          titles: "Facilities",
          tag: "F1",
          tagr: "",
          n: "nf1", // stats primary
          no: "nf1o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Facility is physical collection of assets and units that together deliver business value. The facility management supports tactical planning of business and technical processes to ensure safe, reliable and efficient operations, the three key streams which support the facility are Operations, Maintenance, Engineering and Management.",
          icon: "place",
          icons: "home",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "AO",
          // eslint-disable-next-line
          help1: "Facility is collection of technicals system and assets which operate together to generate business value.",
          // eslint-disable-next-line
          help2: "Facility management is responsible for safety, operations, maintenance and engineering  of all work and projects conducted at the facility. The facility is essential to create new asset and management of asset register.",
          // eslint-disable-next-line
          help3: "Access to approved facility can be promoted and revoked at the discretion of the Facility Custodian, who is responsible for Data Privacy protection of the facility users."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Relationship",
          titles: "Relationships",
          tag: "K4",
          tagr: "",
          n: "nk4", // stats primary
          no: "nk4o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Imported documents internal.",
          icon: "share",
          icons: "home",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "AO",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Notification",
          titles: "Notifications",
          tag: "O1",
          tagr: "",
          n: "no1", // stats primary
          no: "no1o", // stats secondary open / active
          // eslint-disable-next-line
          card: "Operational observation or confirm operation or note an abnormal event or report safety hazard.",
          // eslint-disable-next-line
          des: "Facility is physical collection of assets and units that together deliver business value. The facility management supports tactical planning of business and technical processes to ensure safe, reliable and efficient operations, the three key streams which support the facility are Operations, Maintenance, Engineering and Management.",
          icon: "notifications",
          icons: "home",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BC",
          // eslint-disable-next-line
          help1: "Operations notification is reporting tool to notify facility management about new defects, unexpected operational results and outcomes, equipment faults, performance degradation or notification to confirm correct operation",
          // eslint-disable-next-line
          help2: "Anyone can raise Ops Notification which could originate form maintenance routines, project activity and operational tasks.",
          // eslint-disable-next-line
          help3: "The notification can be escalated to Work Request, Incident Report or Engineering Study to analyse the identified risk or opportunity with additional resources. "
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Permit",
          titles: "Permits",
          tag: "O5",
          tagr: "",
          n: "no5", // stats primary
          no: "no5o", // stats secondary open / active
          // eslint-disable-next-line
          card: "Operational observation or confirm operation or note an abnormal event or report safety hazard.",
          // eslint-disable-next-line
          des: "Facility is physical collection of assets and units that together deliver business value. The facility management supports tactical planning of business and technical processes to ensure safe, reliable and efficient operations, the three key streams which support the facility are Operations, Maintenance, Engineering and Management.",
          icon: "description",
          data: "L",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BC",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Asset",
          titles: "Assets",
          tag: "A1",
          tagr: "",
          n: "na1", // stats primary
          no: "na1o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Asset is a physical object that can be installed, tested, operated and maintained to ensure its design function integrity for total life cycle of the facility. Multiple assets working together form a unit or system or facility where asset design operations create business value.",
          icon: "emoji_transportation",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "AO",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Risk",
          titles: "Risks",
          tag: "B1",
          tagr: "",
          n: "nb1", // stats primary
          no: "nb1o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Asset is a physical object that can be installed, tested, operated and maintained to ensure its design function integrity for total life cycle of the facility. Multiple assets working together form a unit or system or facility where asset design operations create business value.",
          icon: "emergency",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          // eslint-disable-next-line
          help1: "The Risk Assessment is a structured method to identify potential undesired outcomes to business operations. Risk analysis should propose risk management framework to ensure that known and potential risk exposures are as low as as practicably possible.",
          // eslint-disable-next-line
          help2: "The financial or technical risk assessment can be used to communicate known and potential hazards, trends and non compliances to the stakeholders and facility managers. Risk assessment concurred by commercial and technical experts can be recommended to the management team to seek budget and approval to reduce the risk exposure.",
          // eslint-disable-next-line
          help3: "The risk assessment can be company wide, constrained to facility operations or specific to asset or materials."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Material",
          titles: "Materials",
          tag: "L1",
          tagr: "",
          n: "nl1", // stats primary
          no: "nl1o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Material is a physical component with defined technical and order information. A collection of materials can be a bill of materials attached to the asset structure.",
          icon: "category",
          icons: "home",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          // eslint-disable-next-line
          help1: "Material is consumable or component which is part of asset or production units. In addition a collection of materials assigned to an asset is known as Bill of Materials (BOM).",
          // eslint-disable-next-line
          help2: "Parts are be stored in a warehouse or ordered ‘just in time’ for planned or breakdown activity. Removed materials from the machine or system can be discarded, repaired, refurbished or mothballed.",
          // eslint-disable-next-line
          help3: "Stock movement will have immediate and direct impact on budget."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "BOM",
          titles: "BOM",
          tag: "L2",
          tagr: "",
          n: "nl2", // stats primary
          no: "nl2o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Material is a physical component with defined technical and order information. A collection of materials can be a bill of materials attached to the asset structure.",
          icon: "formatted_list_bulleted",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Inventory",
          titles: "Inventory",
          tag: "L7",
          tagr: "",
          n: "nl7", // stats primary
          no: "nl7o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Material is a physical component with defined technical and order information. A collection of materials can be a bill of materials attached to the asset structure.",
          icon: "warehouse",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Action",
          titles: "Actions",
          tag: "B3",
          tagr: "",
          n: "nb3", // stats primary
          no: "nb3o", // stats secondary open / active
          // eslint-disable-next-line
          card: "Management of actions, tasks and audits and allocation of resources.",
          // eslint-disable-next-line
          des: "Asset is a physical object that can be installed, tested, operated and maintained to ensure its design function integrity for total life cycle of the facility. Multiple assets working together form a unit or system or facility where asset design operations create business value.",
          icon: "task",
          icons: "home",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BC",
          // eslint-disable-next-line
          help1: "Action is a business process that can provide certainty to commercial, technical, operational and strategic  decisions.",
          // eslint-disable-next-line
          help2: "The action can be corrective, investigative or preventative and likely it requires resources and plan to complete.",
          // eslint-disable-next-line
          help3: "All actions can only be created by business process with enabled action generator, like risk assessments, incident investigations, work request etc. The scope of the action may be facility specific or company wide."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Budget",
          titles: "Budgets",
          tag: "B4",
          tagr: "",
          n: "nb4", // stats primary
          no: "nb4o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Asset is a physical object that can be installed, tested, operated and maintained to ensure its design function integrity for total life cycle of the facility. Multiple assets working together form a unit or system or facility where asset design operations create business value.",
          icon: "savings",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          // eslint-disable-next-line
          help1: "Budget Plan is a register of proposed expenditures for a given fiscal period. The funds are allocated to specific cause and the cost profile is time bound. Approval of Financial Budget will also have impact on Carbon Budget.",
          // eslint-disable-next-line
          help2: "The budget items can be operational, maintenance, warehousing and projects related. All budget request buy products and services to ensure business continuity.",
          // eslint-disable-next-line
          help3: "Budget approval process must be rigours to ensure cost management. Approved budget will have immediate and material impact on company cash flow or credit thereby the expenditure must be supported by risk analysis, maintenance strategy or engineering study."
          // eslint-disable-next-line
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Plan",
          titles: "Plans",
          tag: "B6",
          tagr: "",
          n: "nb6", // stats primary
          no: "nb6o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Asset is a physical object that can be installed, tested, operated and maintained to ensure its design function integrity for total life cycle of the facility. Multiple assets working together form a unit or system or facility where asset design operations create business value.",
          icon: "today",
          icons: "home",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          // eslint-disable-next-line
          help1: "Operation plans are used to combine multiple facility work requests which share common isolation scheme, geographical area or skill set.",
          // eslint-disable-next-line
          help2: "The plans can include work request, work calls and engineering modifications which can be completed under single campaign execution plan to ensure efficiency.",
          // eslint-disable-next-line
          help3: "The execution plans may include hundreds of requests and integrated planning is essential to ensure the facility is ready for campaign style execution model to ensure smooth work activities."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Limit",
          titles: "Limits",
          tag: "B7",
          tagr: "",
          n: "nb7", // stats primary
          no: "nb7o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Business plan limits, resources, budget or carbon limits.",
          icon: "data_saver_on",
          data: "L", // data model D - document, L - list item
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Order",
          titles: "Orders",
          tag: "Q1",
          tagr: "",
          n: "nq1", // stats primary
          no: "nq1o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Order manages a transfer of value between financial units.",
          icon: "shopping_bag",
          data: "D",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BE",
          // eslint-disable-next-line
          help1: "Financial Order is transfer of value between two parties internal or external.",
          // eslint-disable-next-line
          help2: "Business operational, maintenance, engineering or warehousing activities may require external services or parts to complete assigned task. The Order Request is a tool to manage transfer of goods and services from the supplier to the request originator.",
          // eslint-disable-next-line
          help3: "Order can be only created from approved Material or Work Request and only company management can release order to approve payments to vendors and contractors."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Part",
          titles: "Parts",
          tag: "L5",
          tagr: "",
          n: "nl5", // stats primary
          no: "nl5o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Part is physical components that is used for work request.",
          icon: "apps",
          data: "L",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Resource",
          titles: "Resources",
          tag: "H5",
          tagr: "",
          n: "nh5", // stats primary
          no: "nh5o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Human resource requirements for the work or project activity.",
          icon: "group",
          data: "L",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BE",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Document Revision",
          titles: "Document Revisions",
          tag: "D1",
          tagr: "D.R",
          n: "nd1", // stats primary
          no: "nd1o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Document revision (rev) control is the process of creating new document or authorising changes to the document or simply monitoring history of document revisions.",
          icon: "summarize",
          icons: "home",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "AO",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Document Change Tracker",
          titles: "Document Change Trackers",
          tag: "D2",
          tagr: "D.CT",
          n: "nd2", // stats primary
          no: "nd2o", // stats secondary open / active
          icon: "history",
          icons: "",
          // eslint-disable-next-line
          des: "A document change tracker is a historian of all data mods completed to the document which are logged with a time stamp and person who made the document change, where some document changes may require authorisation and approval.",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "AO",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Document Actvity Log",
          titles: "Document Actvity Log",
          tag: "D3",
          tagr: "D.LOG",
          n: "nd3", // stats primary
          no: "nd3o", // stats secondary open / active
          icon: "list",
          icons: "",
          // eslint-disable-next-line
          des: "Activty Log",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "AO",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Document Check Out",
          titles: "Check Out",
          tag: "D4",
          tagr: "D.CHK",
          n: "nd4", // stats primary
          no: "nd4o", // stats secondary open / active
          icon: "logout",
          icons: "",
          des: "Check Out",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Attachments",
          titles: "",
          tag: "D5",
          tagr: "D.ATT",
          n: "nd5", // stats primary
          no: "nd5o", // stats secondary open / active
          icon: "attach_file",
          icons: "",
          // eslint-disable-next-line
          des: "Attachments",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Storage",
          titles: "",
          tag: "D6",
          tagr: "D.STG",
          n: "nd6", // stats primary
          no: "nd6o", // stats secondary open / active
          icon: "save",
          icons: "",
          // eslint-disable-next-line
          des: "Check Out",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Document Links",
          titles: "Links",
          tag: "D7",
          tagr: "D.LNK",
          n: "nd7", // stats primary
          no: "nd7o", // stats secondary open / active
          icon: "link",
          icons: "",
          // eslint-disable-next-line
          des: "Links",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Skill",
          titles: "Skills",
          tag: "H1",
          tagr: "H.SKI",
          n: "nh1", // stats primary
          no: "nh1o", // stats secondary open / active
          icon: "settings",
          // eslint-disable-next-line
          des: "Specific learned abilities that you will require to perform a given job successfully. In addition hard skill is a technical and quantifiable skill that a professional may demonstrate through their specific qualifications and professional experiences, a soft skill is a non-technical skill that is less rooted in specific vocations [source: www.hays.com.au].",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Competency",
          titles: "Competencies",
          tag: "H2",
          tagr: "H.COM",
          n: "nh2", // stats primary
          no: "nh2o", // stats secondary open / active
          icon: "psychology",
          // eslint-disable-next-line
          des: "Competency is the capability to apply or use the set of related knowledge, skills, and abilities required to successfully perform ‘critical work functions’ or tasks in a defined work setting. Competencies often serve as the basis for skill standards that specify the level of knowledge, skills, and abilities required for success in the workplace as well as potential measurement criteria for assessing comp attainment. Competence is a measure of both proven skills and proven knowledge [source: www.dmp.wa.gov.au].",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Certificate",
          titles: "Certificates",
          tag: "H3",
          tagr: "H.CER",
          icon: "local_activity",
          n: "nh3", // stats primary
          no: "nh3o", // stats secondary open / active
          // eslint-disable-next-line
          des: "A cert is a formally assessed training theoretical and / or practical which outcome is new skill. Assessment is the formal process of collecting evidence of the competencies (skills and knowledge) a worker or engineer has developed through: a structured learning environment, on-the-job training, off-the-job training, other relevant workplace experience [source: www.dmp.wa.gov.au].",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Licence",
          titles: "Licences",
          tag: "H4",
          tagr: "H.LIC",
          icon: "badge",
          n: "nh4", // stats primary
          no: "nh4o", // stats secondary open / active
          // eslint-disable-next-line
          des: "A licensing system is in place to ensure only competent workers carry out high risk work. A licence is a right to perform specialist work which is acknowledged by independent body based on training and experience, example Electrical Worker Licence [source: www.dmp.wa.gov.au].",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Experience",
          titles: "",
          tag: "H6",
          n: "nh6", // stats primary
          no: "nh6o", // stats secondary open / active
          tagr: "H.EXP",
          icon: "work",
          // eslint-disable-next-line
          des: "A licensing system is in place to ensure only competent workers carry out high risk work. A licence is a right to perform specialist work which is acknowledged by independent body based on training and experience, example Electrical Worker Licence [source: www.dmp.wa.gov.au].",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Access",
          titles: "",
          tag: "G1",
          tagr: "G.ACC",
          n: "ng1", // stats primary
          no: "ng1o", // stats secondary open / active
          icon: "key",
          icons: "home",
          // eslint-disable-next-line
          des: "Access to company or facility",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Watchlist",
          titles: "",
          tag: "G2",
          tagr: "G.WAT",
          n: "ng2", // stats primary
          no: "ng2o", // stats secondary open / active
          icon: "star",
          icons: "home",
          // eslint-disable-next-line
          des: "Watchlist",
          stat: "P", // document status when created
          sec: "S1", // document security level when created
          type: "BP",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Hazard",
          titles: "Hazards",
          n: "ns1", // stats primary
          no: "ns1o", // stats secondary open / active
          card: "Hazard awareness during operations and maintenance execution.",
          tag: "S1",
          tagr: "",
          // eslint-disable-next-line
          des: "Asset is a physical object that can be installed, tested, operated and maintained to ensure its design function integrity for total life cycle of the facility. Multiple assets working together form a unit or system or facility where asset design operations create business value.",
          icon: "warning",
          icons: "home",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BC",
          // eslint-disable-next-line
          help1: "Hazard is potential risk exposure to facility staff and contractors who undertake operations, maintenance and projects activities.",
          // eslint-disable-next-line
          help2: "The hazard themes can range from electricity, chemical, radiation and others where uncontrolled release of energy near persons undertaking work could result in injury and environmental impact. The scope of the hazard could reach companywide operations or specific facility production units.",
          // eslint-disable-next-line
          help3: "Related hazards should be reviewed during planning and execution phase of  operational, maintenance and project activities. Any new hazard identified should be immediately reported to facility management, work planning should be modified and work execution should be stopped."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Assessment",
          titles: "Assessments",
          tag: "S2",
          tagr: "",
          n: "ns2", // stats primary
          no: "ns2o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Analysis of risk analysis considering barrier and controls for any activity.",
          icon: "stacked_bar_chart",
          data: "L",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BC",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Barrier",
          titles: "Barriers",
          tag: "S3",
          tagr: "",
          n: "ns3", // stats primary
          no: "ns3o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Recommended risk barriers that should be applied to work or hazard.",
          icon: "shield",
          icons: "home",
          data: "A",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BC",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Control",
          titles: "Controls",
          tag: "S4",
          tagr: "",
          n: "ns4", // stats primary
          no: "ns4o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Recommended risk controls that should be applied to work or hazard.",
          icon: "support",
          icons: "home",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BC",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Outcome",
          titles: "Outcomes",
          tag: "S5",
          tagr: "",
          n: "ns5", // stats primary
          no: "ns5o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Recommended risk controls that should be applied to work or hazard.",
          icon: "share",
          data: "A",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BC",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Incident",
          titles: "Incidents",
          tag: "S6",
          tagr: "",
          n: "ns6", // stats primary
          no: "ns6o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Asset is a physical object that can be installed, tested, operated and maintained to ensure its design function integrity for total life cycle of the facility. Multiple assets working together form a unit or system or facility where asset design operations create business value.",
          // eslint-disable-next-line
          card: "Report safety incidents and events which impact health and safety.",
          icon: "report",
          icons: "home",
          stat: "P", // document status when created
          sec: "S3", // document security level when created
          type: "BE",
          // eslint-disable-next-line
          help1: "Incident is an event which resulted in interruption to business operations, equipment damage, environmental impact or an injury.",
          // eslint-disable-next-line
          help2: "Facility operations and business activities can result in undesired outcomes, like near misses, major accidents, health and safety incidents and others. Incident investigations are required to prevent repeat of events which can be achieved through implementing corrective, investigative or preventative actions.",
          // eslint-disable-next-line
          help3: "Incidents investigation plan may require regulatory compliance together with investigation sponsors and investigation leader."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Cause",
          titles: "Causes",
          tag: "S7",
          tagr: "",
          n: "ns7", // stats primary
          no: "ns7o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Safety causes for incident or event.",
          // eslint-disable-next-line
          card: "Report saftey incident and events which resulted in environmental impact or asset damage.",
          icon: "hdr_weak",
          model: "A",
          stat: "P", // document status when created
          sec: "S3", // document security level when created
          type: "BE",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Maintenance Activity",
          titles: "Maintenance Activities",
          tag: "M1",
          tagr: "",
          n: "nm1", // stats primary
          no: "nm1o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Work request enables release of resources to plan and execute facility repair, replace, upgrade and inspection activities.",
          // eslint-disable-next-line
          card: "Maintenance or project work request, resource planning and safe execution management.",
          icon: "build_circle",
          data: "L",
          stat: "P", // document status when created
          sec: "S2", // document security level was created
          type: "BC",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Maint Strategy",
          titles: "Maintenance Strategies",
          tag: "M2",
          tagr: "",
          n: "nm2", // stats primary
          no: "nm2o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Maintenance Strategy is collection of recommended Maintenance Activity to achieved target facility unit or system reliability outcomes.",
          // eslint-disable-next-line
          card: "Maintenance or project work request, resource planning and safe execution management.",
          icon: "explore",
          data: "L",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BC",
          // eslint-disable-next-line
          help1: "Maintenance strategy is business justification process to implement time based or condition based facility maintenance to prevent equipment failure and to protect high system reliability.",
          // eslint-disable-next-line
          help2: "Maintenance strategy is equipment based analysis tool to select failure modes and to identify industry approved and practicable inspection and test methods to measure equipment condition. In some cases the failure modes patterns are random and engineering judgment must be applied to select appropriate maintenance strategy regime.",
          // eslint-disable-next-line
          help3: "The maintenance strategy is company level document, and the key relationship is Maintenance Plan which is facility level execution tool. The Maintenance Strategy should be reviewed periodically to ensure optimised cost and reliability outcomes."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Maint Plan",
          titles: "Maintenance Plans",
          tag: "M5",
          tagr: "",
          n: "nm5", // stats primary
          no: "nm5o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Maintenance Plan is execution maintenance plan for list of assets based on approved Maintenance Strategy.",
          // eslint-disable-next-line
          card: "Maintenance or project work request, resource planning and safe execution management.",
          icon: "work_history",
          data: "L",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BC",
          // eslint-disable-next-line
          help1: "Maintenance plan is structured time based maintenance tool where the maintenance requests can be coordinated at facility level.",
          // eslint-disable-next-line
          help2: "Maintenance plan is multi asset based planning tool which enables to generate work requests as per approved procedure and identified resource plan. Maintenance plan can only be generated by approved Maintenance Strategy.",
          // eslint-disable-next-line
          help3: "Maintenance Plan key relationship is Maintenance Call which is time record for called maintenance plan. There is only one maintenance strategy assigned to the maintenance plan – but the plan can have many maintenance calls."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Maint Call",
          titles: "Maintenance Calls",
          tag: "M7",
          tagr: "",
          n: "nm7", // stats primary
          no: "nm7o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Maintenance Call is a record of called Maintenence Plan for specific plan execution dates.",
          // eslint-disable-next-line
          card: "Maintenance or project work request, resource planning and safe execution management.",
          icon: "work",
          data: "L",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BC",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Work Request",
          titles: "Work Requests",
          tag: "W1",
          tagr: "",
          n: "nw1", // stats primary
          no: "nw1o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Work request enables release of resources to plan and execute facility repair, replace, upgrade and inspection activities.",
          // eslint-disable-next-line
          card: "Maintenance or project work request, resource planning and safe execution management.",
          icon: "build",
          icons: "home",
          data: "D",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BC",
          // eslint-disable-next-line
          help1: "Work is a request to complete physical project or maintenance activity at specific facility. The task may range from non intrusive inspection, project modification or major maintenance activity which requires facility outage.",
          // eslint-disable-next-line
          help2: "There are two main types of work: general requests and preventative requests, where the work request is generated from time based maintenance plan which is compliant to approved maintenance strategy. Additionally work request may have assigned regulatory compliance attribute to indicate a requirement to complete the activity by specified due date to comply with local legislation.",
          // eslint-disable-next-line
          help3: "Work execution will have material impact to facility operations, due to financial and carbon costs, interruption to normal business operations and higher exposure to facility risks whilst conducting the activity. In addition, work planning may require to comply with facility specific permit to work system, site access inductions and local health and safety rules."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Work Call",
          titles: "Work Calls",
          tag: "W2",
          tagr: "",
          n: "nw2", // stats primary
          no: "nw2o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Work call is generated by the Maintenance Plan and the scope of work is either an Inspection or Function Test or Preventative Minatence.",
          // eslint-disable-next-line
          card: "Maintenance or project work request, resource planning and safe execution management.",
          icon: "work_outline",
          data: "D",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BC",
          // eslint-disable-next-line
          help1: "Work is a request to complete physical project or maintenance activity at specific facility. The task may range from non intrusive inspection, project modification or major maintenance activity which requires facility outage.",
          // eslint-disable-next-line
          help2: "There are two main types of work: general requests and preventative requests, where the work request is generated from time based maintenance plan which is compliant to approved maintenance strategy. Additionally work request may have assigned regulatory compliance attribute to indicate a requirement to complete the activity by specified due date to comply with local legislation.",
          // eslint-disable-next-line
          help3: "Work execution will have material impact to facility operations, due to financial and carbon costs, interruption to normal business operations and higher exposure to facility risks whilst conducting the activity. In addition, work planning may require to comply with facility specific permit to work system, site access inductions and local health and safety rules."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Task",
          titles: "Tasks",
          tag: "W5",
          tagr: "",
          n: "nw5", // stats primary
          no: "nw5o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Procedure is a task list which safe and relaiable execution of an activity, which may be opertaional or maintenace or project.",
          // eslint-disable-next-line
          card: "Maintenance or project work request, resource planning and safe execution management.",
          icon: "summarize",
          data: "D",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BC",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Procedure",
          titles: "Procedures",
          tag: "W6",
          tagr: "",
          n: "nw6", // stats primary
          no: "nw6o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Procedure is a task list which safe and relaiable execution of an activity, which may be opertaional or maintenace or project.",
          // eslint-disable-next-line
          card: "Maintenance or project work request, resource planning and safe execution management.",
          icon: "assignment",
          data: "D",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BC",
          // eslint-disable-next-line
          help1: "Procedure is step by step instruction on how to complete project or maintenance task. The procedure detail is an outcome of best industry practices, incident investigation recommendations and local or global standards requirements.",
          // eslint-disable-next-line
          help2: "In some cases, the procedure is safety critical or certain tasks are required to achieve regulatory compliance. In any case a deviation to approved procedure shall be approved by the Engineering Request.",
          // eslint-disable-next-line
          help3: "The procedure is a live document, and it should be reviewed and updated periodically to reflect changes in the operating philosophy or facility modifications. A continuous improvement mindset should be applied to procedure document lifecycle managed by executive leaders, Operations, Maintenance or Projects."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Result",
          titles: "Results",
          tag: "E5",
          tagr: "",
          n: "ne5", // stats primary
          no: "ne5o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Procedure is a task list which safe and relaiable execution of an activity, which may be opertaional or maintenace or project.",
          // eslint-disable-next-line
          card: "Maintenance or project work request, resource planning and safe execution management.",
          icon: "biotech",
          data: "D",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BE",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Program",
          titles: "Program",
          tag: "E6",
          tagr: "",
          n: "ne6", // stats primary
          no: "ne6o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Procedure is a task list which safe and relaiable execution of an activity, which may be opertaional or maintenace or project.",
          // eslint-disable-next-line
          card: "Maintenance or project work request, resource planning and safe execution management.",
          icon: "science",
          data: "D",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BE",
          // eslint-disable-next-line
          help1: "Inspection and Test Program Management is common method to store equipment test and inspection data which was collected using approved Procedure with appropriate test instruments.",
          // eslint-disable-next-line
          help2: "Prescribed method to store equipment test data can enable trending of time based failure modes and compare how equipment degradation varies between facilities and applications uses.",
          // eslint-disable-next-line
          help3: "Inspection results could be also used a business optimisation tool to check if currently established maintenance strategies and inspection regimes are fit for purpose and value add with respect to inspection trends."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Report",
          titles: "Report",
          tag: "E8",
          tagr: "",
          n: "ne8", // stats primary
          no: "ne8o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Facility inspection and test results, which were completed during maintenance or project.",
          // eslint-disable-next-line
          card: "Facility inspection and test results, which were completed during maintenance or project.",
          icon: "add_chart",
          data: "D",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "BE",
          // eslint-disable-next-line
          help1: "Inspection and Test Report is a record of test and inspection data for asset, component or material. The technical result can be generated during planned maintenance activity, on and off site project activities or ad hoc equipment inspection.",
          // eslint-disable-next-line
          help2: "The technical results can be prepared by local facility staff or by expert vendor, and additionally facility engineer or manager can validate the results for quality.",
          // eslint-disable-next-line
          help3: "Inspection and test results may be used to identify new vulnerabilities or opportunities, as well as provide input to opex and capex budget cycles and strategic plans."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Analysis",
          titles: "Analysis",
          tag: "E3",
          tagr: "",
          n: "ne4", // stats primary
          no: "ne3o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Failure risk analysis of equipment or asset.",
          // eslint-disable-next-line
          card: "Engineering study, risk assessment, equipment selection and projects.",
          icon: "assignment_late",
          icons: "home",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "AO",
          help1: "",
          help2: "",
          help3: ""
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Equipment",
          titles: "Equipment",
          tag: "E1",
          tagr: "",
          n: "ne1", // stats primary
          no: "ne1o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Technical objects that are foundation for asset building.",
          // eslint-disable-next-line
          card: "Engineering study, risk assessment, equipment selection and projects.",
          icon: "emoji_objects",
          icons: "home",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "AO",
          // eslint-disable-next-line
          help1: "Equipment type is attribute assigned to facility assets and materials and it defines technical, performance or functional requirements.",
          // eslint-disable-next-line
          help2: "Assets describe applications and where used, and their key technical property is equipment type. Common technical specifications can be used to order materials in bulk, identify systemic issues and plan for obsolescence.",
          // eslint-disable-next-line
          help3: "Equipment can range from static mechanical, rotating equipment, electrical, instrumentation, control, chemical and other types."
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Engineering",
          titles: "Engineering",
          tag: "E2",
          tagr: "",
          n: "ne2", // stats primary
          no: "ne2o", // stats secondary open / active
          // eslint-disable-next-line
          des: "Technical objects that are foundation for asset building.",
          // eslint-disable-next-line
          card: "Engineering study, risk assessment, equipment selection and projects.",
          icon: "settings",
          icons: "home",
          data: "D",
          stat: "P", // document status when created
          sec: "S2", // document security level when created
          type: "AO",
          // eslint-disable-next-line
          help1: "Technical queries and engineering studies are required to ensure compliance to management of change procedures.",
          // eslint-disable-next-line
          help2: "Facility modifications and temporary deviations from the standards and approved procedures are managed by engineering requests where approved technical change is recommended to facility manager for engineering endorsement.",
          // eslint-disable-next-line
          help3: "The engineering request is technical analysis and approval to implement modification in the field but the actual execution of technical change is managed by the Work Request. Alternatively engineering request could result in approval to operate under temporary operating procedure."
        }
      ]
    };
  }
};
